exports = module.exports = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._3-16TgU9HBclQd-U8TJOyr{height:52px!important;width:44px!important}html[dir] ._3-16TgU9HBclQd-U8TJOyr:hover{background:\"[theme:neutralLighter, default:#f3f2f1]\"}", ""]);
// Exports
exports.locals = {
	"personaSuggestionIconButton": "_3-16TgU9HBclQd-U8TJOyr"
};